module.exports = __webpack_public_path__ + "img/Rectangle 16.6322ff8d.png";